/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralRecipientConfig } from './ReferralRecipientConfig';
import {
    ReferralRecipientConfigFromJSON,
    ReferralRecipientConfigFromJSONTyped,
    ReferralRecipientConfigToJSON,
    ReferralRecipientConfigToJSONTyped,
} from './ReferralRecipientConfig';

/**
 * 
 * @export
 * @interface FindAllReferralRecipientConfigs200Response
 */
export interface FindAllReferralRecipientConfigs200Response {
    /**
     * 
     */
    data?: Array<ReferralRecipientConfig>;
}

/**
 * Check if a given object implements the FindAllReferralRecipientConfigs200Response interface.
 */
export function instanceOfFindAllReferralRecipientConfigs200Response(value: object): value is FindAllReferralRecipientConfigs200Response {
    return true;
}

export function FindAllReferralRecipientConfigs200ResponseFromJSON(json: any): FindAllReferralRecipientConfigs200Response {
    return FindAllReferralRecipientConfigs200ResponseFromJSONTyped(json, false);
}

export function FindAllReferralRecipientConfigs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllReferralRecipientConfigs200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ReferralRecipientConfigFromJSON)),
    };
}

export function FindAllReferralRecipientConfigs200ResponseToJSON(json: any): FindAllReferralRecipientConfigs200Response {
    return FindAllReferralRecipientConfigs200ResponseToJSONTyped(json, false);
}

export function FindAllReferralRecipientConfigs200ResponseToJSONTyped(value?: FindAllReferralRecipientConfigs200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ReferralRecipientConfigToJSON)),
    };
}

